// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListGatewaysQueryVariables = Types.Exact<{
  input: Types.CashierFindPaymentGatewayConfigInput;
}>;


export type ListGatewaysQuery = { __typename?: 'Query', cashier?: { __typename: 'Cashier', id: string, gatewaysConfig?: { __typename: 'CashierGatewayConnection', edges?: Array<{ __typename: 'CashierGatewayEdge', node?: { __typename: 'CashierPaymentGateway', method?: string, provider?: string, urlAlias?: string } }> } } };


export const ListGatewaysDocument = /*#__PURE__*/ gql`
    query ListGateways($input: CashierFindPaymentGatewayConfigInput!) {
  cashier {
    id
    gatewaysConfig(input: $input) {
      edges {
        node {
          __typename
          method
          provider
          urlAlias
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;
export function useListGatewaysQuery(baseOptions: Apollo.QueryHookOptions<ListGatewaysQuery, ListGatewaysQueryVariables> & ({ variables: ListGatewaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGatewaysQuery, ListGatewaysQueryVariables>(ListGatewaysDocument, options);
      }
export function useListGatewaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGatewaysQuery, ListGatewaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGatewaysQuery, ListGatewaysQueryVariables>(ListGatewaysDocument, options);
        }
export function useListGatewaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListGatewaysQuery, ListGatewaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListGatewaysQuery, ListGatewaysQueryVariables>(ListGatewaysDocument, options);
        }
export type ListGatewaysQueryHookResult = ReturnType<typeof useListGatewaysQuery>;
export type ListGatewaysLazyQueryHookResult = ReturnType<typeof useListGatewaysLazyQuery>;
export type ListGatewaysSuspenseQueryHookResult = ReturnType<typeof useListGatewaysSuspenseQuery>;
export type ListGatewaysQueryResult = Apollo.QueryResult<ListGatewaysQuery, ListGatewaysQueryVariables>;